import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { useTranslation } from 'core/i18n';
import { MenuProps } from '../app.menu.type';

export const TrainingsMenu: React.FC<Pick<MenuProps, 'onNavigationClick'>> = ({ onNavigationClick }) => {
    const { t } = useTranslation();
    return (
        <PocListItem
            size="medium"
            onClick={(ev) => {
                ev.stopPropagation();
                onNavigationClick('trainings');
            }}
            value="trainings"
            data-testid="trainings-menu-item"
            variant="side-menu"
        >
            <PocIcon slot="prefix" name="certificate" family="filled" data-testid="trainings-menu-icon" />
            {t('app.sidemenu.options.trainings')}
        </PocListItem>
    );
};
